<template lang="pug">
b-modal(v-model="showModal" title="Edit Announcement" size="lg" scrollable) 
    div(class="w-100 ")
        b-form-group(label="Title")
            b-form-input(v-model="title" placeholder="Enter Title" required :class="{ 'is-invalid': title.length < 1 && title.length > 0 }" )
        b-form-group(label="Body")
            div(:class="{ 'invalidVueEditor': body.length < 1 && body.length > 0 }")
                VueEditor(v-model="body" :editorToolbar="customToolbar" placeholder="Enter Body" required)
    
        b-form-group(label="Only Clients" class="mt-3")
            b-form-checkbox(v-model="isClients" switch)
        b-form-group(label v-if="!isClients")
            v-select( id="event-group"  :options="groups" :reduce="item => ({ id: item.id, name: item.name })" multiple label="name" placeholder="Select Group" :class="{'invalid': selectedGroup.length === 0}" v-model="selectedGroup")
        b-form-group(label="Clients" v-if="isClients")
            v-select(
                class="w-100"
                v-model="selectedClients"
                :options="searchedClients"
                :loading="loadingSearch"
                :filterable="false"
                @search="search"
                :multiple="true"
                label="name"
                track-by="id"
                :reduce="option => option"
                :class="{'invalid': selectedClients.length === 0}"
                )
                    template(#no-options)
                        p Type to search users by name
                    template(#option="option")
                        div {{ option.name }}
                    template(#selected-option="option")
                        div {{ option.name }}
        div(class="d-flex justify-content-between")
            p Pinned 
            b-form-checkbox(v-model="isPinned" switch) 
        hr(v-if="isPinned")
        div(class="d-flex flex-column" v-if="isPinned")
            p Expiry Date for Pinned Announcement
            b-form-datepicker(v-model="expiryDate" :min="new Date()" placeholder="Select a Date" :class="{'invalid': expiryDate === ''}")
        div(class="d-flex flex-column my-3" v-if="isPinned")
            p Expiry Time for Pinned Announcement
            b-form-timepicker(v-model="expiryTime" placeholder="Select a Time" :class="{'invalid': expiryTime === ''}" locale="en" )
        p Select Images for Announcement
        div(class="d-flex flex-wrap")
            b-form-file(v-model="newImages" accept="image/*" multiple)
        div(class="d-flex flex-row my-3 justify-content-between" v-if="imgObj?.images?.length > 0 || newImages?.length > 0")
            p Downloadable
            b-form-checkbox(v-model="imgObj.imageDownloadable" switch)

        p(v-if="newImages?.length > 0") New Images
        div(class="d-flex flex-wrap w-100")
            div(v-for="(image, index) in newImages" :key="index" class="d-flex flex-row preview" v-if="newImages?.length > 0")
                div(class="d-flex flex-column image-cont")
                    img(:src="fileToImage(image)" class="img-fluid" alt="preview")
                    b-button(@click="newImages.splice(index, 1)" variant="danger") Remove
        p(v-if="imgObj?.images?.length > 0") Existing Images    
        div(class="d-flex flex-wrap w-100")
            div(v-for="(image, index) in imgObj.images" :key="index" class="d-flex flex-row preview" v-if="imgObj?.images?.length > 0")
                div(class="d-flex flex-column image-cont")
                    img(:src="image.downloadURL" class="img-fluid" alt="preview")
                    b-button(@click="imgObj.images.splice(index, 1)" variant="danger") Remove

    template(v-slot:modal-footer)
        b-button(@click="showModal = false" :disabled="loading") Cancel
        b-button(@click="submit" variant="primary" :disabled="!validateTitle || !validateBody || loading") 
            span(v-if="loading") 
                b-spinner(type="grow" small)
            span(v-else) Update
</template>


<script>
import { VueEditor } from "vue2-editor";
import axios from "axios";
import debounce from "lodash.debounce";
export default {
    components: {
        VueEditor,
    },
    props: ["showEditDialog", "groups", "announcement"],

    data() {
        return {

            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                ],
                ["link"],
                ["clean"],
            ],
            title: "",
            body: "",
            selectedGroup: [],
            isPinned: false,
            error: {
                title: "",
                body: "",
            },
            loading: false,
            expiryDate: "",
            expiryTime: "",
            imgObj:{images:[],imageDownloadable:false},
            newImages: [],
            isClients: false,
            selectedClients: [],
            searchedClients: [],
            loadingSearch: false,

        };
    },
    // async mounted() {
    //     if (this.announcement) {
            
    //         this.title = this.announcement.title;
    //         this.body = this.announcement.body;
    //         this.isPinned = this.announcement.isPinned === 1 ? true : false;
    //         this.selectedGroup = this.announcement.groups;
    //         if (this.announcement.expiryDate && this.announcement.expiryDate !== "") {
    //             const expiryDateTime = new Date(this.announcement.expiryDate);
    //             expiryDateTime.setDate(expiryDateTime.getDate() + 1);
    //             this.expiryDate = expiryDateTime.toISOString().split("T")[0];
    //             this.expiryTime = expiryDateTime.toTimeString().split(" ")[0];
    //         }
            
    //     }    

    // },
    methods: {
        search: debounce(async function(query) {
            if (!query || query.length < 2) {
                this.searchedClients = [];
                return;
            }

            this.loadingSearch = true;
            try {
                const res = await axios.post(`/api/announcement/v2/searchClient?search=${encodeURIComponent(query)}`, {
                    search: query,
                });
                if (res.status === 200) {
                    this.searchedClients = res.data?.clients || [];
                }
            } catch (error) {
                console.error(error);
                this.$root.$bvToast.toast("An error occurred while searching for clients", {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                });
            } finally {
                this.loadingSearch = false;
            }
        }, 300),
        fileToImage(file) {
            return URL.createObjectURL(file);
        },
        
        consoleLog() {
            console.log(this.title)
            console.log(this.$root)
        },
        
        async submit () {
            if (this.isClients ? this.selectedClients.length === 0 : this.selectedGroup.length === 0) {
                this.$root.$bvToast.toast(this.isClients ? "Please select at least one client" : "Please select a group", {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            if (this.validateTitle && this.validateBody) {
                this.loading = true;
                try{
                // const data = {
                //     id: this.announcement.id,
                //     title: this.title,
                //     body: JSON.stringify(this.body),
                //     isPinned: this.isPinned,
                //     groupIds: JSON.stringify(this.selectedGroup.map((item) => item.id),),
                //     expiryDate: this.isPinned ? new Date(this.expiryDate + " " + this.expiryTime).toISOString() : null,
                // };
                const formData = new FormData();
                formData.append("id", this.announcement.id);
                formData.append("title", this.title);
                formData.append("body", JSON.stringify(this.body));
                formData.append("isPinned", this.isPinned);
                formData.append("groupIds", JSON.stringify(this.isClients ? [] : this.selectedGroup.map((item) => item.id)));
                formData.append("recipientIds", JSON.stringify(this.isClients ? this.selectedClients.map((item) => item.id) : []));
                formData.append("targetedRecipients", this.isClients ? true : false);
                formData.append("expiryDate", this.isPinned ? new Date(this.expiryDate + " " + this.expiryTime).toISOString() : null);
                formData.append("imageDownloadable", this.imgObj.imageDownloadable);
                formData.append("oldImages", JSON.stringify(this.imgObj.images ? this.imgObj.images.map((item) => item.id) : []));
                this.newImages.forEach((image) => {
                    formData.append("images", image);
                });
                

                const res = await axios.put("/api/announcement/v2", 
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
                );
                console.log(res)
                if (res.status === 200) {
                    this.showModal = false;
                    this.$emit("updated", res.data?.data);
                }
                this.$root.$bvToast.toast("Announcement updated", {
                    title: "Success",
                    variant: "success",
                    solid: true,
                });
            }
            catch(e){
                console.log(e)
                this.$root.$bvToast.toast("Error updating announcement", {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                });
            }
            finally{
                this.loading = false;
            }
            }
        },
    },
    computed: {


        showModal: {
            get() {
                return this.showEditDialog;
            },
            set(value) {
                this.$emit("update:showEditDialog", value);
            },
        },
        validateTitle() {
            if(!this.title) return
            return this.title.length >= 1;
        },
        validateBody() {
            if(!this.body) return
            return this.body.length >= 1;
        },
    },
    watch: {
    showModal(newVal) {
        if (!newVal) {
            this.title = "";
            this.body = "";
            this.isPinned = false;
            this.error = {
                title: "",
                body: "",
            };
            this.selectedGroup = [];
            this.expiryDate = "";
            this.expiryTime = "";
            this.imgObj = {images: [], imageDownloadable: false};
            this.newImages = [];
            this.isClients = false;
            this.selectedClients = [];
            this.searchedClients = [];
        } else {
            this.title = this.announcement.title;
            this.body = this.announcement.body;
            this.isPinned = this.announcement.isPinned === 1 ? true : false;
            this.selectedGroup = this.announcement.groups;
            this.isClients = this.announcement.targetedRecipient === true;
            this.selectedClients = (this.announcement.clientsDetails || []).map((client) => ({
                id: client.id || client.crb5c_fow_customerid,
                name: client.name || client.crb5c_no,
            }));
            if (this.announcement.expiryDate && this.announcement.expiryDate !== "") {
                const expiryDateTime = new Date(this.announcement.expiryDate);
                expiryDateTime.setDate(expiryDateTime.getDate() + 1);
                this.expiryDate = expiryDateTime.toISOString().split("T")[0];
                this.expiryTime = expiryDateTime.toTimeString().split(" ")[0];
            }


            this.imgObj = JSON.parse(JSON.stringify(this.announcement.imgObj));
        }
    },


        announcement(newVal) {
            if (newVal) {
                this.title = newVal.title;
                this.body = newVal.body;
                this.isPinned = newVal.isPinned === 1 ? true : false;
                this.selectedGroup = newVal.groups;
                this.isClients = newVal.targetedRecipient === true;
                this.selectedClients = (newVal.clientsDetails || []).map((client) => ({
                    id: client.id || client.crb5c_fow_customerid,
                    name: client.name || client.crb5c_no,
                }));
                if (newVal.expiryDate && newVal.expiryDate !== "") {
                    const expiryDateTime = new Date(newVal.expiryDate);
                    expiryDateTime.setDate(expiryDateTime.getDate() + 1);
                    this.expiryDate = expiryDateTime.toISOString().split("T")[0];
                    this.expiryTime = expiryDateTime.toTimeString().split(" ")[0];
                }
            }
        },
    },
    
};
</script>
<style lang="scss" scoped>
.image-cont {
    margin: 10px;
    position: relative;
    padding: 5px;
    border: 1px solid #ACB5BD;
    border-radius: 10px;
    width:100%;
    
    img {
        width: 200px;
        height: 200px;
        object-fit: cover;
    }

    button {
        position: absolute;
        top: 5px;
        right: 5px;
        border: none;
        z-index: 1;
    }
}

.preview {
    margin: 10px;
    position: relative;
}
</style>
